import React, { PureComponent } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import Spinner from '../../components/Spinner';
import Form from '../../components/Admins/Form';
import PageTitle from '../../components/PageTitle';
import BackButton from '../../components/BackButton';
import ErrorDialog from '../../components/ErrorDialog';
import PasswordForm from '../../components/PasswordForm';
import Snackbar from '../../containers/SnackbarContainer';

class EditAdmin extends PureComponent {
  constructor() {
    super();

    this.handleShowAdmin = this.handleShowAdmin.bind(this);
  }

  componentDidMount() {
    this.handleShowAdmin();
  }

  handleShowAdmin() {
    const { match: { params }, showAdmin } = this.props;
    showAdmin(params.id);
  }

  render() {
    const { currentAdmin, isFetching, updateAdmin, error, clearError } = this.props;

    return (
      <Grid container alignItems="center">
        <Grid item>
          <BackButton history={this.props.history} />
        </Grid>
        <Grid item xs={12}>
          <PageTitle> Editar Administrador </PageTitle>
        </Grid>
        <Grid item xs={12}>
          { !isEmpty(currentAdmin) &&
            <Form
              editable
              admin={currentAdmin}
              onSubmit={updateAdmin}
              errors={error.errors}
            />
          }
        </Grid>
        <Grid item xs={12}>
          <PasswordForm
            user="admin"
            onSubmit={updateAdmin}
            errors={error.errors}
            userId={currentAdmin.id}
          />
        </Grid>
        { isFetching && <Spinner /> }
        { (error.error || error.message) &&
          <ErrorDialog error={error.error || error.message} action={clearError} />
        }
        <Snackbar />
      </Grid>
    );
  }
}

export default EditAdmin;

EditAdmin.propTypes = {
  history: PropTypes.object.isRequired,
  updateAdmin: PropTypes.func.isRequired,
  showAdmin: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  currentAdmin: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  clearError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Admins/EditAdmin.js